import { useEffect, useState } from "react";

import { NEXA_TURN_SLOW_MS } from "../constants";
import type { TurnPhase } from "../types";
import NexaLoader from "./NexaLoader";

const formatElapsed = (ms: number) => {
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m ${String(s % 60).padStart(2, "0")}s`;
};

const TurnProgress = ({ phases, startedAt }: { phases: TurnPhase[]; startedAt: number }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const elapsed = now - startedAt;
  const current = phases[phases.length - 1];
  const done = phases.slice(0, -1);

  return (
    <div className="tw-flex tw-gap-3 tw-rounded-xl tw-border tw-border-[#EAE8F5] tw-bg-[#FAFAFE] tw-p-3">
      <NexaLoader label={current?.label ?? "Nexa is working"} />

      <div className="tw-min-w-0 tw-flex-1 tw-self-center">
        {done.map((phase) => (
          <div key={phase.id} className="tw-mb-1 tw-flex tw-items-center tw-gap-2 tw-text-label-sm tw-text-gray-500">
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true" className="tw-shrink-0">
              <path d="M2.5 6.3 5 8.8 9.5 3.5" stroke="#4D7C0F" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="tw-truncate">{phase.label}</span>
          </div>
        ))}

        {current && (
          <>
            <div className="tw-text-label-sm tw-font-semibold tw-text-[#1E1B4B]">{current.label}</div>
            <div className="tw-mt-0.5 tw-flex tw-items-center tw-gap-2 tw-text-label-xs tw-text-gray-500">
              <span>{formatElapsed(elapsed)}</span>
              {current.retries ? (
                <span className="tw-text-[#92610A]">· checking the answer again</span>
              ) : null}
            </div>
          </>
        )}

        {elapsed > NEXA_TURN_SLOW_MS && <div className="tw-mt-2 tw-text-label-xs tw-leading-relaxed tw-text-gray-500">Still working…</div>}
      </div>
    </div>
  );
};

export default TurnProgress;
